/** Approximates how the browser will upload the image (see prepareImageForUpload). */
export function describeUploadImage(src: string | null): { mimeType: string; size: string } {
  if (!src) return { mimeType: 'image/jpeg', size: 'No image selected' };
  const mimeType = src.startsWith('data:image/png')
    ? 'image/png'
    : src.startsWith('data:image/webp')
      ? 'image/webp'
      : 'image/jpeg';
  if (!src.includes(';base64,')) return { mimeType, size: 're-encoded on upload' };
  const base64Length = src.length - (src.indexOf(',') + 1);
  return { mimeType, size: `${Math.round((base64Length * 3) / 4 / 1024)} KB` };
}

/** The Gemini `generateContent` request the backend sends, with the image bytes elided. */
export function buildPayloadPreview(input: {
  model: string;
  image: string | null;
  prompt: string;
  aspectRatio: string;
}) {
  const { mimeType, size } = describeUploadImage(input.image);
  return {
    model: input.model,
    contents: {
      parts: [
        {
          inlineData: {
            mimeType,
            data: input.image ? `<Base64 Image Bytes: ${size} (${mimeType})>` : '<Property Photo Base64 Required>',
          },
        },
        { text: input.prompt },
      ],
    },
    config: { imageConfig: { aspectRatio: input.aspectRatio } },
  };
}
